import {Injectable} from '@angular/core';

import {DeeplinkService} from 'app/service/deeplink/deeplink.service';

@Injectable({
    providedIn: 'root',
})
export class LocationGuard {
    constructor(private deeplinkService: DeeplinkService) {}

    canActivate(): boolean {
        return !this.deeplinkService.locationHasHashtagRoute();
    }
}
